import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { getLoggedUser } from './redux/auth/actions'
import { utils } from './database'

// react-router-dom v7: PrivateRoute deixa de ser <Route render=...> e vira
// um wrapper component. Recebe `element` (padrão v7) ou `component` (legado
// v5 ainda em uso por alguns sites). Em qualquer caso, redireciona para
// /login se o usuário não está logado.
const PrivateRoute = ({ component: Component, element, logged, ...rest }) => {
  const location = useLocation()
  if (!(logged && logged.userId)) {
    const target = rest.route === '/loginAntigo' ? '/loginAntigo' : '/login'
    return <Navigate to={target} state={{ from: location }} replace />
  }
  if (element) {
    // Clona injetando logged + props remanescentes — preserva semântica v5.
    return React.cloneElement(element, { logged, ...rest })
  }
  return <Component logged {...rest} />
}

const propsFromDatabase = async () => ({
  logged: await getLoggedUser(),
})

export default utils.withPropsFromDatabase(propsFromDatabase, PrivateRoute)
